import { useState, useEffect } from 'react';
import { useAppStore } from '../store/appStore';
import './SessionPrompt.css';

export function SessionPrompt() {
    const [customMinutes, setCustomMinutes] = useState('');
    const { currentProfile, profiles, setCurrentProfile, startSession, durationHistory } = useAppStore();

    // Ensure a profile is set
    useEffect(() => {
        if (!currentProfile && profiles.length > 0) {
            setCurrentProfile(profiles[0]);
        }
    }, [currentProfile, profiles, setCurrentProfile]);

    const handleStart = (minutes: number) => {
        if (minutes > 0) {
            startSession(minutes);
        }
    };

    const handleCustomStart = () => {
        const mins = parseInt(customMinutes, 10);
        if (mins > 0 && mins <= 480) {  // Max 8 hours
            handleStart(mins);
        }
    };

    // Format duration for display
    const formatDuration = (mins: number) => {
        if (mins >= 60) {
            const hours = Math.floor(mins / 60);
            const remaining = mins % 60;
            return remaining > 0 ? `${hours}h ${remaining}m` : `${hours}h`;
        }
        return `${mins} min`;
    };

    return (
        <div className="session-prompt">
            <div className="session-prompt__content">
                <div className="session-prompt__icon">
                    {currentProfile?.avatarId || '👶'}
                </div>
                <h1 className="session-prompt__title">How long can you watch?</h1>

                {/* Recent duration choices (LIFO order) */}
                <div className="session-prompt__grid">
                    {durationHistory.slice(0, 6).map((minutes, index) => (
                        <button
                            key={`${minutes}-${index}`}
                            className="session-prompt__option"
                            onClick={() => handleStart(minutes)}
                        >
                            {formatDuration(minutes)}
                        </button>
                    ))}
                </div>

                {/* Custom input */}
                <div className="session-prompt__custom">
                    <input
                        type="number"
                        inputMode="numeric"
                        min="1"
                        max="480"
                        value={customMinutes}
                        onChange={e => setCustomMinutes(e.target.value.replace(/\D/g, ''))}
                        placeholder="Other (minutes)"
                        className="session-prompt__input"
                    />
                    <button
                        className="session-prompt__custom-btn"
                        onClick={handleCustomStart}
                        disabled={!customMinutes || parseInt(customMinutes) <= 0}
                    >
                        Start
                    </button>
                </div>
            </div>
        </div>
    );
}
